/**
 * 商铺系统路由配置
 */

const shopRoutes = [
  {
    path: '/shop/list',
    name: 'ShopList',
    component: () => import('../views/shop/ShopList.vue'),
    meta: { title: '商铺列表' }
  },
  {
    path: '/shop/:shopId/edit',
    name: 'ShopEdit',
    component: () => import('../views/shop/ShopEdit.vue'),
    meta: { title: '商铺装修' }
  },
  {
    path: '/shop/:shopId/preview',
    name: 'ShopPreview',
    component: () => import('../views/shop/ShopPreview.vue'),
    meta: { title: '商铺预览' }
  },
  {
    path: '/shop/market',
    name: 'StyleMarket',
    component: () => import('../views/shop/StyleMarket.vue'),
    meta: { title: '风格市场' }
  },
  {
    path: '/activity/list',
    name: 'ActivityList',
    component: () => import('../views/activity/ActivityList.vue'),
    meta: { title: '活动管理' }
  },
  {
    path: '/shop/:shopId/activities',
    name: 'ShopActivityManage',
    component: () => import('../views/shop/ShopActivityManage.vue'),
    meta: { title: '商铺活动管理' }
  }
]

export default shopRoutes

